export const environment = {
  production: false,
  lite: false,
  appTitle: 'Li-Dance Backoffice Suite',
  apiUrl: 'https://dev.li-dance.de/plan/api/',
  apiKeyPublic: '754259b6-caf0-4eca-a1f6-812731adae79',
  apiKeyInternal: '1ca6fc7d-d5b8-473c-a44d-a8c9098e2940',
};